export default {
    animation: Boolean | Object,
    ARIATemplate: String,
    culture: String,
    dateInput: Boolean,
    dates: Array,
    depth: String,
    disableDates: Array | Function,
    footer: String,
    format: String,
    interval: Number,
    max: Date,
    min: Date,
    month: Object,
    weekNumber: Boolean,
    parseFormats: Array,
    start: String,
    timeFormat: String,
    value: String | Date,

    // Events
    change: Function,
    close: Function,
    open: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoDateTimePicker/DateTimePickerProps.js